<template>
  <base-dialog show-close :visible.sync="visible" class="edit-dialog">
    <template v-slot:header>{{ title }}</template>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" label-position="left">
      <el-form-item v-if="isCreate" label="手机号/邮箱" prop="telephone">
        <el-input :disabled="!isCreate" v-model="form.telephone"></el-input>
      </el-form-item>
      <template v-else>
        <el-form-item label="手机号" prop="telephone">
          <el-input :disabled="!isCreate" v-model="form.telephone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="姓名" prop="name">
        <el-input :disabled="!isCreate" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="职位" prop="position">
        <el-input v-model="form.position" :disabled="currentCompany.syncDing"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="departmentIds">
        <user-scope-selector
          :disabled="currentCompany.syncDing"
          v-model="form.departmentIds"
          :show-user-tab="false"
          :root-department="rootDepartment"
          multiple
          tip="选择部门"
        ></user-scope-selector>
      </el-form-item>
      <el-form-item label="汇报对象" prop="superior">
        <user-selector v-model="form.superior" single-value-mode></user-selector>
      </el-form-item>
      <el-form-item label="企业角色" prop="roleIds">
        <el-select
          v-model="form.roleIds"
          placeholder="请选择"
          size="small"
          filterable
          multiple
          :disabled="!isCreate && currentCompany.ownerId === userInfo.id"
        >
          <el-option
            v-for="item in roles"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserSelector from "@/components/FormControl/UserSelector"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import {
  addUserToCompany,
  getCompanyRolesWithNum,
  updateCompanyUser
} from "@/api/userCenter/company"
import { verifyJoinRecord } from "@/api/user"

export default {
  name: "company-user-edit-dialog",
  components: { BaseDialog, BaseButton, UserSelector, UserScopeSelector },
  inject: ["rootDepartment", "currentCompany"],
  props: {
    from: {
      type: String,
      default: ""
    },
    recordId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      form: {},
      roles: [],
      userInfo: null
    }
  },
  computed: {
    isCreate() {
      return !this.userInfo
    },
    title() {
      return this.isCreate ? "添加成员" : "编辑成员"
    },
    rules() {
      return this.isCreate
        ? {
            telephone: [{ required: true, message: "请填写手机号/邮箱", trigger: "blur" }],
            departmentIds: [{ required: true, message: "请选择部门", trigger: "change" }],
            superior: [{ required: true, message: "请选择汇报对象", trigger: "change" }],
            roleIds: [{ required: true, message: "请选择角色", trigger: "change" }]
          }
        : {
            departmentIds: [{ required: true, message: "请选择部门", trigger: "change" }],
            superior: [{ required: true, message: "请选择汇报对象", trigger: "change" }],
            roleIds: [{ required: true, message: "请选择角色", trigger: "change" }]
          }
    }
  },
  created() {
    getCompanyRolesWithNum().then(data => (this.roles = data))
  },
  methods: {
    open(userInfo) {
      this.userInfo = userInfo
      if (userInfo) {
        this.$set(this.form, "name", userInfo.name)
        this.$set(this.form, "telephone", userInfo.telephone)
        this.$set(this.form, "email", userInfo.email)
        this.$set(this.form, "position", userInfo.companyScope?.position)
        this.$set(
          this.form,
          "departmentIds",
          userInfo.companyScope?.departmentIds.map(id => ({ type: "department", value: id })) || []
        )
        this.$set(this.form, "userId", userInfo.id)
        this.$set(this.form, "superior", userInfo.companyScope?.superior)
        this.$set(this.form, "roleIds", userInfo.companyRoleIds)
      } else {
        this.form = { departmentIds: [] }
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let form = this._.cloneDeep(this.form)
        form.departmentIds = form.departmentIds.map(t => t.value)
        if (this.isCreate) {
          addUserToCompany(form).then(() => {
            this.$message.success("添加成功")
            this.$emit("change")
            this.visible = false
          })
          //
        } else {
          if (this.from === "invite-review") {
            verifyJoinRecord(true, this.recordId, form).then(() => {
              this.$emit("refresh")
              this.visible = false
            })
          } else {
            updateCompanyUser(form).then(() => {
              this.$message.success("更新成功")
              this.$emit("change")
              this.visible = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
    }
  }
  .el-form ::v-deep {
    .el-form-item {
      margin-bottom: 8px;
      .el-form-item__error {
        position: relative;
      }
    }
    .el-form-item__label,
    .el-form-item__content,
    .el-input,
    .el-cascader {
      line-height: 32px;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
